import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import NightAuditNavigation from "./NightAuditNavigation";
import NightAuditFolioItems from "./steps/NightAuditFolioItems/NightAuditFolioItems";
import NightAuditPaymentsWorkspace from "./steps/NightAuditPayments/NightAuditPaymentsWorkspace";
import NightAuditCCAuthorizationsWorkspace from "./steps/NightAuditCCAuthorizations/NightAuditCCAuthorizationsWorkspace";
import NightAuditNoShow from "./steps/NightAuditNoShows/NightAuditNoShow";
import NightAuditConfirmation from "./steps/NightAuditConfirmation/NightAuditConfirmation";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DateHelper from '../DateHelper/DateHelper';
import numeral from "numeral";


class NightAudit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          step: 'folio_items',
          loading: true, 
          totals: {},
          cc_auths: [],
          postDate: DateHelper.parseDateFromBackend(this.props.post_date),
          no_shows: [],
          excluded_folio_items: [],
          excluded_payments: [],
          excluded_authorizations: [],
          excluded_check_in_authorizations: [],
          excluded_no_shows: [],
          audit_date: DateHelper.parseDateFromBackend(this.props.date),
          // refunded_total: 0,
          deposits: [],
          payment_logs: [],
          check_in_auths: [],
          check_in_auths_date: DateHelper.parseDateFromBackend(this.props.check_in_auths_date),
          no_show_date: DateHelper.parseDateFromBackend(this.props.post_date),
        };
        this.changeStep = this.changeStep.bind(this);
        this.cancel = this.cancel.bind(this);
        this.collectDataAndTotals = this.collectDataAndTotals.bind(this);
        this.collectCCAuthorizations = this.collectCCAuthorizations.bind(this);
        this.collectCheckInAuthorizations = this.collectCheckInAuthorizations.bind(this);
        this.collectNoShows = this.collectNoShows.bind(this);
        this.onChangePostDate = this.onChangePostDate.bind(this);
        this.excludeFolioItems = this.excludeFolioItems.bind(this);
        this.excludePayments = this.excludePayments.bind(this);
        this.excludeAuthorizations = this.excludeAuthorizations.bind(this);
        this.excludeCheckInAuthorizations = this.excludeCheckInAuthorizations.bind(this);
        this.excludeNoShow = this.excludeNoShow.bind(this);
        this.collectPaymentLogs = this.collectPaymentLogs.bind(this);
        this.onChangeCheckInDate = this.onChangeCheckInDate.bind(this);
        this.onChangeNoShowDate = this.onChangeNoShowDate.bind(this);
    };

    render() {
      let buttons = this.setButtons()
        return (
            <div className="night-audit NightAudit">
              <NightAuditNavigation step={this.state.step}
                changeStep={this.changeStep}
                />
              <br/>
              {this.renderSteps()}
              <ModalButtons loading={this.state.loading} buttons={buttons} />
              <LoadingSpinner show={this.state.loading} />
            </div>
        );
    };

    renderSteps() {
      if (this.state.step === "folio_items") {
        return <NightAuditFolioItems 
                  {...this.props}
                  {...this.state}
                  formatCurrency={this.formatCurrency}  
                  collectDataAndTotals={this.collectDataAndTotals}
                  onChangePostDate={this.onChangePostDate}
                  excludeFolioItems={this.excludeFolioItems}
                  excludedFolioItems={this.state.excluded_folio_items}
                />
      } else if (this.state.step === "payments") {
        return <NightAuditPaymentsWorkspace {...this.props} 
                  {... this.state}
                  formatCurrency={this.formatCurrency}
                  collectDataAndTotals={this.collectDataAndTotals}
                  excludePayments={this.excludePayments}
                  // updateRefundedTotal={this.updateRefundedTotal}
                  collectPaymentLogs={this.collectPaymentLogs}
                  collectDeposites={this.collectDeposites}
                />
      } else if (this.state.step === "cc_authorizations") {
        return <NightAuditCCAuthorizationsWorkspace {...this.props}
                  {...this.state}
                  formatCurrency={this.formatCurrency}
                  collectCCAuthorizations={this.collectCCAuthorizations}
                  collectCheckInAuthorizations={this.collectCheckInAuthorizations}
                  excludeAuthorizations={this.excludeAuthorizations}
                  excludeCheckInAuthorizations={this.excludeCheckInAuthorizations}
                  onChangeCheckInDate={this.onChangeCheckInDate}
                />
      } else if (this.state.step === "no_shows") {
        return <NightAuditNoShow {...this.props}
                  {...this.state}
                  formatCurrency={this.formatCurrency}
                  collectNoShows={this.collectNoShows}
                  excludeNoShow={this.excludeNoShow}
                  onChangeNoShowDate={this.onChangeNoShowDate}
                />
      } else if (this.state.step === "confirmation") {
        return <NightAuditConfirmation {...this.props}
                {...this.state}
                formatCurrency={this.formatCurrency} 
              />
      }
    };

    setButtons() {
      if (this.state.step === "folio_items") {
        var buttons = [
          {
            name: I18n.t('prev'),
            html_attributes: [
              'disabled'
            ]
          },
          {
            name: I18n.t('next'),
            html_attributes: this.state.loading ? ['disabled'] : null,
            button_classes: ['primary'],
            onClick: (e) => {
                this.setState({
                  step: "payments",
                  loading: true,
                });
            }
          }
        ];
      } else if (this.state.step === "payments") {
        var buttons = [
          {
            name: I18n.t('prev'),
            html_attributes: this.state.loading ? ['disabled'] : null,
            onClick: (e) => {
              this.setState({
                step: "folio_items",
                loading: true,
              });
            }
          },
          {
            name: I18n.t('next'),
            html_attributes: this.state.loading ? ['disabled'] : null,
            button_classes: ['primary'],
            onClick: (e) => {
              this.setState({
                step: "cc_authorizations", 
                loading: true,
              });
            }
          }
        ];
      } else if (this.state.step === "cc_authorizations") {
        var buttons = [
          {
            name: I18n.t('prev'),
            onClick: (e) => {
              this.setState({
                step: "payments",
                loading: true
              });
            }
          },
          {
            name: I18n.t('next'),
            button_classes: ['primary'],
            onClick: (e) => {
              this.setState({
                step: "no_shows",
                loading: true
              });
            }
          }
        ];
      } else if (this.state.step === "no_shows") {
        var buttons = [
          {
            name: I18n.t('prev'),
            onClick: (e) => {
              this.setState({
                step: "cc_authorizations",
                loading: true
              });
            }
          },
          {
            name: I18n.t('complete_audit'),
            button_classes: ['primary'],
            onClick: (e) => {
              this.finalize()
              this.setState({
                loading:true
              });
            }
          }
        ];
      } else if (this.state.step === "confirmation") {
        var buttons = [
          {
            name: I18n.t('done'),
            button_classes: ['primary'],
            onClick: (e) => {
              parent.refresh_data()
              $(window).trigger('refresh_data_table');
              parent.hide_modal();
              // setTimeout(function () {
              // }, 3000);
              // if (parent && parent.hide_modal) {
              // };
            }
          }
        ]
      }
      return buttons
    };

    changeStep(stepName) {
      this.setState({
        step: stepName,
        loading: true,
      });
    };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  onChangeCheckInDate(date){
    this.setState({
      check_in_auths_date: date
    });
  };

  onChangeNoShowDate(date){
    this.setState({
      no_show_date: date
    });
  };

  collectDataAndTotals(name, total, count, product) {
    var totals = Object.assign({}, this.state.totals)
    
    if (product) {
      if (this.state.totals && this.state.totals.products) { 
        let products = Object.assign({}, this.state.totals.products, { [name]: total, [name + '_count']: count})
        totals['products'] = products
        this.setState({
          totals: totals
        })
      } else {
        totals['products'] = { [name]: total, [name + '_count']: count }
        this.setState({
          totals: totals
        });
      };
    } else {
      totals[name] = total
      totals[name + '_count'] = count
      // var loading = this.state.step == 'folio_items' && totals.fees != 'undefined' && totals.lodging != 'undefined' && totals.taxes != 'undefined' ? false : true

      this.setState({
        totals: totals,
        loading: false,
      });
    }; 
  };

  collectCCAuthorizations(data, total, count) {
    var totals = Object.assign({}, this.state.totals)
    totals['cc_auths'] = total
    totals['id_auths_count'] = count
    this.setState({
      cc_auths: data,
      totals: totals,
    });
  };

  collectCheckInAuthorizations(data, count) {
    var totals = Object.assign({}, this.state.totals)
    totals['check_in_auths_count'] = count

    this.setState({
      check_in_auths: data,
      totals: totals,
      loading: false
    });
  };

  collectNoShows(data, count) {
    var totals = Object.assign({}, this.state.totals)
    totals['no_shows_count'] = count

    this.setState({
      no_shows: data,
      loading: false,
      totals: totals
    });
  };

  collectPaymentLogs(data, total, count, refunded) {
    var totals = Object.assign({}, this.state.totals);
    totals['payments'] = total;
    totals['payments_count'] = count;
    totals['payments_refund_total'] = refunded;
 
    var loading = this.state.step == 'payments' && totals.payments != 'undefined' && totals.deposits != 'undefined' ? false : true
    this.setState({
      payment_logs: data,
      totals: totals,
      loading: loading, 
    });
  };

  onChangePostDate(date) {
    this.setState({
      postDate: date,
    });
  };

  excludeFolioItems(data) {
    var excludedItems = this.state.excluded_folio_items.slice(0)

    data.forEach(item => excludedItems.push(item))
    this.setState({
      excluded_folio_items: excludedItems
    });
  };

  excludePayments(data) {
    var excludedPayments = this.state.excluded_payments.slice(0)

    data.forEach(item => excludedPayments.push(item))
    this.setState({
      excluded_payments: excludedPayments
    });
  };

  excludeAuthorizations(data) {
    var excludedAuthorizations = this.state.excluded_authorizations.slice(0)

    data.forEach(item => excludedAuthorizations.push(item))
    this.setState({
      excluded_authorizations: excludedAuthorizations
    });
  };

  excludeCheckInAuthorizations(data) {
    var excludedAuthorizations = this.state.excluded_check_in_authorizations.slice(0)

    data.forEach(item => excludedAuthorizations.push(item))
    this.setState({
      excluded_check_in_authorizations: excludedAuthorizations
    });
  };

  excludeNoShow(data) {
    var excludedNoShow = this.state.excluded_no_shows.slice(0)

    data.forEach(item => excludedNoShow.push(item))
    this.setState({
      excluded_no_shows: excludedNoShow
    });
  };

  cancel() {
    this.setState({
      loading: true
    });
    $.ajax({
      type: 'POST',
      url: `/admin/night-audits/${this.props.night_audit.id}/cancel`
    }).done((data) => {
      if(data.success) {
        this.setState({
          loading: false
        })
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        };

      };
    });
  };

  finalize() {
    $.ajax({
      type: 'POST',
      url: `/admin/night-audits/finalize`,
      data: {night_audit: this.setParams()}
    }).done((data) => {
      if (data.response) {
        this.setState({
          step: 'confirmation',
          confirmationResponse: data.response,
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
        });
      };
    });
  };

  setParams() {
    var params = {
      post_date: this.state.postDate,
      excluded_folio_items: this.state.excluded_folio_items,
      totals: this.buildTotalsObj(),
      count: this.buildCountObj(),
      excluded_payments: this.state.excluded_payments,
      excluded_auths: this.state.excluded_authorizations,
      excluded_check_in_authorizations: this.state.excluded_check_in_authorizations,
      excluded_no_shows: this.state.excluded_no_shows,
      check_in_auths_date: this.state.check_in_auths_date,
      no_show_date: this.state.no_show_date,
    };
    return params
  };

  buildTotalsObj() {
    var totalsCopy = Object.assign({}, this.state.totals)
    
    var productsTotalCopy = Object.assign({}, this.state.totals.products)
    var products_total_breakdown = Object.keys(productsTotalCopy).reduce((acc, key) => {
      if(!key.includes('_count')){
        acc[key.toLowerCase()]= productsTotalCopy[key];
      };
      return acc
    }, {});
    var totals = Object.keys(totalsCopy).reduce((acc, key) => {
      if (!key.includes('_count') && key != 'products'){
        acc[key.toLocaleLowerCase()] = totalsCopy[key]
      } else if (key === 'products'){
        acc[key.toLocaleLowerCase()] = Object.keys(productsTotalCopy).reduce((acc, key) => {
          if (!key.includes('_count')) {
            acc+= productsTotalCopy[key];
          };
          return acc
        }, 0);
      };
      return acc
    }, {});
    var folioItemTotal = Object.keys(totalsCopy).reduce((acc, key) => {
      if (!key.includes('_count') && key != 'products' && key != 'payments' && key != 'deposits' && key != 'cc_auths'){
        acc += totalsCopy[key]
      };
      return acc
    }, 0);
    totals.folio_item_totals = folioItemTotal + (totals.products ? totals.products : 0);
    return totals
  };

  buildCountObj(){
    var totalsCopy = Object.assign({}, this.state.totals)
    var productsTotalCopy = Object.assign({}, this.state.totals.products)
    var productCountObj = Object.keys(productsTotalCopy).reduce((acc, key) => {
      if(key.includes('_count')){
        acc[key.toLocaleLowerCase()] = productsTotalCopy[key]
      }
      return acc
    }, {});
    var chargesCount = Object.keys(totalsCopy).reduce((acc, key) => {
      if (key.includes('_count') && key != 'deposits_count' && key != 'payments_count' && key != 'id_auths_count' && key != 'check_in_auths_count' && key != 'no_shows_count' || key === 'products') {
        if (key === "products") {
          acc += this.calculateProductCount(productCountObj)
        } else {
          acc += totalsCopy[key]
        };
      };
      return acc
    }, 0);
    var countObj = Object.keys(totalsCopy).reduce((acc, key) => {
      if (key.includes('_count')) {
        acc[key.toLocaleLowerCase()] = totalsCopy[key]
      }
      return acc
    }, {});

    countObj.products_count = this.calculateProductCount(productsTotalCopy)
    countObj.folio_items_total_count = chargesCount
    countObj.products_count_breakdown = productCountObj
    return countObj
  };

  calculateProductCount(productsTotalObj){
    return Object.keys(productsTotalObj).reduce((acc, key) => {
      if (key.includes('_count')) {
        acc += productsTotalObj[key]
      }
      return acc
    }, 0)
  };
};

export default NightAudit